import { render } from "./defaultFotrm.vue?vue&type=template&id=09ae31a5"
import script from "./defaultFotrm.vue?vue&type=script&lang=js"
export * from "./defaultFotrm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__